<script>
import kvalue_mixin from "@/pages/inspection_reports/form-elements/kvalue_mixin";

export default {
  mixins: [kvalue_mixin]
}
</script>

<template>
  <div class="form-group row" :class="{ [groupClasses]: typeof groupClasses != 'undefined' }">
    <div class="col-4">
      <label class="form-label">{{ label }}</label>
    </div>

    <div class="col-4">
      <Input
          v-bind="$attrs"
          :name="name"
          :model-value="inputValue"
          :required="required"
          @update:modelValue="handleInput"
          @update:option="handleInput"
      />
    </div>

    <div class="col-4">
      <MultipleRadios
          v-bind="$attrs"
          :name="name"
          :model-value="computedValue"
          :required="required"
          :options="[
            { label: 'OK', value: 'OK' },
            { label: 'Fout', value: 'Fout' },
          ]"
          disabled="disabled"
      />
    </div>
  </div>
</template>